"use strict";
exports.__esModule = true;
exports.isIntersection = exports.isUnion = void 0;
/**
 * Check if a value is a union of two types.
 *
 * @public
 */
exports.isUnion = function (ptt, ptu) {
    return function (o) { return ptt(o) || ptu(o); };
};
/**
 * Check if a value is an intersection of two types.
 *
 * @public
 */
exports.isIntersection = function (ptt, ptu) {
    return function (o) { return ptt(o) && ptu(o); };
};
//# sourceMappingURL=functions.js.map